/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { AppBanner as AppBannerComponent } from '@spotahome/ui-library';

const buildDeeplink = (slug = '') => {
  const sessionId =
    typeof window !== 'undefined' && window.__CONTEXT__
      ? window.__CONTEXT__.__EXPERIMENTS_SESSION_ID__
      : '';
  return `https://spotahome.app.link/${slug}${
    sessionId && `?webSessionId=${sessionId}`
  }`;
};

const AppBanner = ({ deviceType }) => {
  const isMobile = deviceType === 'smartphone';

  return isMobile ? (
    <AppBannerComponent
      title={trans('appbanner.title')}
      eventAction="banner-click-homepage"
      openPath={buildDeeplink('banner_home')}
    />
  ) : null;
};

AppBanner.propTypes = {
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default AppBanner;
